import { Badge } from '@/components/ui/badge'
import { Text } from '@/components/ui/text'
import { AppTooltip } from '@components'
import { type Component, For } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import { useChannelsReads } from '../../../state/channelReads/state'
import { useSelectors } from '../../../state/selectors'
import { SharedChannelItem, SharedChannelList } from '../SharedChannel'

const ChannelSetups: Component<{ height?: string; isMinimal?: boolean }> = (props) => {
  const { setupChannels } = useService(useSelectors)()
  const { toggleSubscribed } = useService(useChannelsReads)()

  return (
    <SharedChannelList>
      <For each={setupChannels()}>
        {(channel) => (
          <SharedChannelItem
            href={`/chat/${channel.setup_id}`}
            isMinimal={props.isMinimal}
            channelId={channel.id}
            isSubscribed={channel.is_subscribed} // Updated
            onToggleSubscribe={toggleSubscribed}
            linkOutHref={`/setups/${channel.setup_id}`} // Updated
            unreadCount={channel.unread_count} // Updated
          >
            <Grid gap={0} justifyItems='start'>
              <AppTooltip
                delay={1300}
                className={css({ minW: 0, p: 1 })}
                content={channel.setup_title} // Updated
                openDelay={4000}
              >
                <Text textStyle='sm' textAlign="left" truncate textTransform='capitalize'>
                  {channel.setup_title} {/* Updated */}
                </Text>
              </AppTooltip>

              <Badge variant="surface" size="sm" mb='1'>
                {channel.setup_symbol} {/* Updated */}
              </Badge>
            </Grid>
          </SharedChannelItem>
        )}
      </For>
    </SharedChannelList>
  )
}

export default ChannelSetups
